<template>
  <div>
    <hero></hero>
    <score></score>
    <essay-preview></essay-preview>
    <playback></playback>
    <archive></archive>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Hero from '@/components/Hero.vue'
import Score from '@/components/Score.vue'
import EssayPreview from '@/components/EssayPreview.vue'
import Playback from '@/components/Playback.vue'
import Archive from '@/components/Archive.vue'

export default {
  name: 'chapter',
  components: {
    Hero,
    Score,
    EssayPreview,
    Playback,
    Archive
  },
  props: ['id'],
  computed: {
    ...mapGetters(['chapter'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Chapter.vue?1e343a14